export const renderMiAnalysisStarted = (result = {}) => [
  'Mi Analise iniciada',
  result.fileName ? `Video: ${result.fileName}` : null,
  result.analysisGoal ? `Foco: ${result.analysisGoal}` : null,
  'Vou processar pelo pipeline oficial e te aviso quando o resultado estiver pronto.'
].filter(Boolean).join('\n\n');

export const renderMiAnalysisHumanError = ({ status, message } = {}) => {
  if (status === 403) {
    return message || 'A Mi Analise de video depende do seu acesso Pro atual.';
  }
  return message || 'Nao consegui iniciar a Mi Analise agora. Tenta novamente em instantes.';
};

export default renderMiAnalysisStarted;
